export function getBenefitsGroup(state) {
  return state.BenefitsGroup;
}

export function getSelectedBenefitGroup(state) {
  return state.selectedBenefitGroup;
}
